import React from "react";
import { Check } from "lucide-react";

export const About = () => {
  const specialties = [
    "SEO-friendly website development",
    "Affordable SEO services in USA",
    "AI platform visibility optimization",
    "Technical SEO improvements",
    "Content structure optimization",
    "Conversion-focused landing pages",
    "Authority-building strategies",
    "Semantic and entity-based SEO",
  ];

  return (
    <section id="about" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 relative">
          <div className="relative rounded-3xl overflow-hidden border border-black/5 card-shadow">
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&auto=format&fit=crop&q=70"
              alt="Team collaborating on growth strategy"
              className="w-full h-[420px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-[hsl(var(--brand-navy)/.55)] via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-15 text-white">
              <div className="text-[11px] uppercase tracking-widest text-[hsl(var(--brand-amber))]">Since day one</div>
              <div className="mt-1 font-[Fraunces] text-2xl font-semibold">Growth systems, not just websites.</div>
            </div>
          </div>

          <div className="absolute -bottom-8 -right-4 sm:right-8 rounded-2xl bg-white border border-black/5 card-shadow p-5 max-w-[240px]">
            <div className="font-[Fraunces] text-3xl font-bold text-brand-deep">100+</div>
            <div className="text-xs text-slate-500 mt-1">Projects across healthcare, e-commerce, tech, manufacturing & more.</div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="inline-flex items-center gap-2 rounded-full bg-lilac px-3.5 py-1 text-xs font-medium text-brand-deep border border-[hsl(var(--brand-violet)/.15)]">
            About Rankify Dev
          </div>
          <h2 className="mt-4 text-4xl sm:text-5xl font-bold text-[hsl(var(--brand-navy))] leading-[1.08]">
            We are more than <span className="text-gradient-brand">just an SEO agency</span>
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            Rankify Dev is a development and digital marketing brand focused on helping businesses grow online through modern SEO and
            performance-driven web solutions. As a division of Webify IT Solutions, we work with startups, local businesses, and growing brands across multiple industries.
          </p>

          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {specialties.map((s) => (
              <li key={s} className="flex items-start gap-2 text-sm text-slate-700">
                <span className="mt-0.5 h-5 w-5 rounded-md brand-gradient grid place-items-center shrink-0">
                  <Check className="h-3 w-3 text-white" />
                </span>
                {s}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
